var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"}));
}

Circle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Circle;

Circle.default = Circle;
